const cartOverlay = document.getElementById("cart-overlay");
const sideCart = document.getElementById("side-cart");
const navOverlay = document.getElementById("nav-overlay");
const sideNav = document.getElementById("side-nav");

// =====================================================
// CART / NAVIGATION
// =====================================================

function openCart() {
  if (sideCart) {
    sideCart.classList.remove("translate-x-full");
  }

  if (cartOverlay) {
    cartOverlay.classList.remove("hidden");
  }
}

function closeCart() {
  if (sideCart) {
    sideCart.classList.add("translate-x-full");
  }

  if (cartOverlay) {
    cartOverlay.classList.add("hidden");
  }
}

function openNav() {
  if (sideNav) {
    sideNav.classList.remove("-translate-x-full");
  }

  if (navOverlay) {
    navOverlay.classList.remove("hidden");
  }
}

function closeNav() {
  if (sideNav) {
    sideNav.classList.add("-translate-x-full");
  }

  if (navOverlay) {
    navOverlay.classList.add("hidden");
  }
}


// =====================================================
// UPDATE CART QUANTITY
// =====================================================

document.addEventListener("change", function (e) {
  if (!e.target.classList.contains("quantity-input")) return;

  const line = e.target.dataset.line;
  const quantity = parseInt(e.target.value, 10);

  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      line: line,
      quantity: quantity,
    }),
  })
    .then((res) => res.json())
    .then((cart) => {
      if (typeof updateCartDisplay === "function") {
        updateCartDisplay(cart);
      }
    })
    .catch((error) => {
      console.error("Cart quantity update error:", error);
    });
});


// =====================================================
// REMOVE CART ITEM
// =====================================================

document.addEventListener("click", function (e) {
  const removeButton = e.target.closest(".remove-item");

  if (!removeButton) return;

  const line = removeButton.dataset.line;

  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      line: line,
      quantity: 0,
    }),
  })
    .then(() => {
      location.reload();
    })
    .catch((error) => {
      console.error("Remove cart item error:", error);
    });
});


// =====================================================
// AJAX SEARCH
// =====================================================

const searchInput = document.getElementById("ajax-search-input");
const dropdown = document.getElementById("search-dropdown");
const resultsList = document.getElementById("search-results");

let timeout;

if (searchInput && dropdown && resultsList) {

  searchInput.addEventListener("input", function () {

    const query = this.value.trim();

    clearTimeout(timeout);

    if (!query) {
      dropdown.classList.add("hidden");
      resultsList.innerHTML = "";
      return;
    }

    // Delay AJAX to avoid too many requests
    timeout = setTimeout(() => {

      fetch(
        `/search/suggest.json?q=${encodeURIComponent(
          query
        )}&resources[type]=product&resources[limit]=5`
      )
        .then((res) => res.json())
        .then((data) => {

          const products =
            data?.resources?.results?.products || [];

          if (!products.length) {

            resultsList.innerHTML =
              '<li class="p-2 text-gray-500 text-sm">No results found</li>';

          } else {

            resultsList.innerHTML = products
              .map(
                (p) => `
                  <li class="flex items-center p-2 hover:bg-gray-50">
                    <a href="${p.url}" class="flex items-center w-full">

                      ${
                        p.image
                          ? `<img 
                              src="${p.image}" 
                              alt="${p.title}" 
                              class="w-10 h-10 object-cover rounded mr-2"
                            >`
                          : ""
                      }

                      <div class="flex-1 text-sm">
                        <div class="font-medium text-gray-800">
                          ${p.title}
                        </div>

                        <div class="text-gray-500">
                          ${p.price}
                        </div>
                      </div>

                    </a>
                  </li>
                `
              )
              .join("");
          }

          dropdown.classList.remove("hidden");
        })
        .catch((error) => {
          console.error("Search error:", error);
        });

    }, 300);
  });

}


// =====================================================
// HIDE SEARCH DROPDOWN WHEN CLICKING OUTSIDE
// =====================================================

document.addEventListener("click", (e) => {

  if (!searchInput || !dropdown) return;

  if (
    !searchInput.contains(e.target) &&
    !dropdown.contains(e.target)
  ) {
    dropdown.classList.add("hidden");
  }

});


// =====================================================
// QUICK VIEW OPEN
// =====================================================

document.querySelectorAll(".quick-view-trigger").forEach((trigger) => {

  trigger.addEventListener("click", () => {

    const id = trigger.dataset.productId;

    const card = document.querySelector(
      `.quick-preview-card[data-product-id="${id}"]`
    );

    if (card) {
      card.classList.toggle("hidden");
    }

  });

});


// =====================================================
// QUICK VIEW CLOSE
// =====================================================

document.querySelectorAll(".quick-view-close").forEach((closeBtn) => {

  closeBtn.addEventListener("click", () => {

    const id = closeBtn.dataset.productId;

    const card = document.querySelector(
      `.quick-preview-card[data-product-id="${id}"]`
    );

    if (card) {
      card.classList.toggle("hidden");
    }

  });

});


// =====================================================
// BLACKDOG INK - PRODUCT VARIANT FIX
// =====================================================



// =====================================================
// BLACKDOG LIVE TEST
// =====================================================

console.log("BLACKDOG LIVE TEST 123");